module.exports = __webpack_public_path__ + "img/img_aboutus_wave@2x.8c7e4ae7.png";